import { toast } from "react-toastify";
import { ethers } from "ethers";
import transactionContract from "../Containers/App/TransactionAbi.json";
import { process } from "postcss-flexbugs-fixes";

const { ethereum } = window;

const methodList = {
	request_connection: "eth_requestAccounts",
	check_connection: "eth_accounts",
};

export const connectWallet = async (mode, callback) => {
	try {
		let method = methodList.check_connection;

		if (mode === "request") {
			if (!ethereum) return alert("No wallet extension in your browser!");
			method = methodList.request_connection;
		}

		const wallet = await ethereum.request({ method });

		callback && callback(wallet[0]);
		return wallet[0];
	} catch (error) {
		throw new Error(error);
	}
};
export const getContract = async (type) => {
	let contractAbi = transactionContract.abi;
	let contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;

	const provider = new ethers.providers.Web3Provider(ethereum);
	const signer = provider.getSigner();

	return new ethers.Contract(contractAddress, contractAbi, signer);
};
const sendTransaction = async (from, to, amount, cbSuccess, cbFailed) => {
	try {
		if (!ethereum) return toast.error("Please install metamask!");
		const parsedAmount = ethers.utils.parseEther(amount);

		if (ethereum.networkVersion !== process.env.REACT_APP_NETWORK_VERSION) {
			return toast.error("Please change network to Goerli test network!");
		}
		await ethereum.request({
			method: "eth_sendTransaction",
			params: [
				{
					from,
					to,
					gas: "0x5208", // 21000 GWEI
					value: parsedAmount._hex,
				},
			],
		});
		cbSuccess && cbSuccess();
	} catch (error) {
		console.log(error);
		if (error.code !== 4001)
			toast.error("Please sign in on your metamask browser extension!");
		if (error.code === 4001)
			toast.error("Transaction failed because being rejected!");
		cbFailed && cbFailed();
	}
};
export const payNftFee = async (wallet, cbSuccess, cbFailed) => {
	const appWallet = process.env.REACT_APP_FM_ETHER_WALLET;
	const amount = process.env.REACT_APP_NFT_FEE;
	await sendTransaction(wallet, appWallet, amount, cbSuccess, cbFailed);
};
